import { render, staticRenderFns } from "./UpdateKeywordModal.vue?vue&type=template&id=39c7801d"
import script from "./UpdateKeywordModal.vue?vue&type=script&lang=js"
export * from "./UpdateKeywordModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateKeywordModal.vue?vue&type=style&index=0&id=39c7801d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports